/**
 * Store of all hardcoded codeable concepts
 */

import { codes, subcodes } from '@bcm/datastructures';
import { KLExtractor } from './utils';

const KLCodes = {
	conditions: KLExtractor(codes.conditions),
	clinicalStatuses: KLExtractor(codes.clinicalStatuses),
	verificationStatuses: KLExtractor(codes.verificationStatuses),
	// categories: KLExtractor(codes),
	// severities: KLExtractor(codes.severities),
	// burnSeverities: KLExtractor(codes.burnSeverities),
	subcodes: {
		burn: KLExtractor(subcodes.burn),
		stroke: KLExtractor(subcodes.stroke),
	},
	eocTypes: KLExtractor(codes.eocTypes),
	tbsaFormulas: KLExtractor(codes.tbsaFormulas),
	fluidResuscitationFormulas: KLExtractor(codes.fluidResuscitationFormulas),
};

export default KLCodes;